import router from './router/router.js';
import store from './store';
import Vue from 'vue';
import Aegis from '@tencent/aegis-web-sdk';
const { getters, dispatch, commit, state } = store;
const { config } = state;
const AEGIS = {
  test: 'EPqQ3cr2gqdnVJ4m6w',
  prod: '8lqYGtoyxbkqx51mw3',
};

let aegis = null;
if (Aegis) {
  aegis = new Aegis({
  id: getters.getConfigItem('wechat_aegis_key'), // 上报 id
  uin: sessionStorage.getItem('userid') || undefined, // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  hostUrl: 'https://rumt-zh.com',
});
store.commit('user/SET_AEGIS', aegis)
}

Vue.config.errorHandler = (e) => {
  aegis.error(e);
  console.error(e);
  if (e instanceof DOMException && e.name === 'QuotaExceededError') {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i); //获取本地存储的Key
      if (key?.startsWith('ticketId=') || key === 'voiceAI') {
        localStorage.removeItem(key);
      }
    }
  }
};
// 说明：资源地址前缀替换（$processImageUrl / window.open / el-image 覆盖）
// 已统一迁移至 src/main.js，且只在 main.js 定义一份，此处不再重复声明。
// 下方 registerElImageOverride / registerFileUrlGuard 内部是按需读取
// Vue.prototype.$processImageUrl（运行时惰性调用），不依赖本文件的执行时机。

// 精准覆盖 el-image 组件，渲染时补全文件地址前缀
// 说明：DOM 层拦截（registerFileUrlGuard）已能覆盖 el-image 内部渲染的 <img>，
// 这里保留组件层覆盖作为兜底，避免 DOM 层拦截在个别环境下失效时图片全部退回旧地址。
// 用法：在 main.js 中 Vue.use(ElementUI) 之后调用 registerElImageOverride()
export function registerElImageOverride() {
  // 取出 ElementUI 注册到全局的原版 el-image 组件构造器
  const OriginalElImage = Vue.options.components && Vue.options.components.ElImage;
  if (!OriginalElImage) {
    // 兜底：未找到原组件则不做覆盖，避免破坏渲染
    console.warn('[permission] ElImage 未找到，跳过 el-image 覆盖注册');
    return;
  }

  Vue.component('ElImage', {
    name: 'ElImage',
    functional: true,
    render(h, ctx) {
      const props = ctx.props || {};
      const processUrl = Vue.prototype.$processImageUrl;

      // 计算 src 的新值（不修改原引用）
      let nextSrc = props.src;
      let srcChanged = false;
      if (props.src) {
        if (Array.isArray(props.src)) {
          const mapped = props.src.map(url => processUrl(url));
          srcChanged = mapped.some((url, i) => url !== props.src[i]);
          if (srcChanged) nextSrc = mapped;
        } else {
          const mapped = processUrl(props.src);
          if (mapped !== props.src) {
            nextSrc = mapped;
            srcChanged = true;
          }
        }
      }

      // 计算 previewSrcList 的新值（不修改原数组）
      let nextPreviewSrcList = props.previewSrcList;
      let previewChanged = false;
      if (Array.isArray(props.previewSrcList)) {
        const mapped = props.previewSrcList.map(url => processUrl(url));
        previewChanged = mapped.some((url, i) => url !== props.previewSrcList[i]);
        if (previewChanged) nextPreviewSrcList = mapped;
      }

      // 仅当确实有变化时，才覆盖对应字段，其余 props/attrs/listeners/scopedSlots 透传
      const finalProps = (srcChanged || previewChanged)
        ? Object.assign({}, props, {
            src: nextSrc,
            previewSrcList: nextPreviewSrcList,
          })
        : props;

      return h(
        OriginalElImage,
        {
          props: finalProps,
          attrs: ctx.data.attrs,
          on: ctx.listeners,
          nativeOn: ctx.data.nativeOn,
          scopedSlots: ctx.data.scopedSlots,
          class: ctx.data.class,
          staticClass: ctx.data.staticClass,
          style: ctx.data.style,
          staticStyle: ctx.data.staticStyle,
          ref: ctx.data.ref,
          refInFor: ctx.data.refInFor,
          directives: ctx.data.directives,
        },
        ctx.children,
      );
    },
  });
}

// ============ 文件链接渲染统一拦截（DOM 层） ============
//
// 为什么放在 DOM 层而不是覆盖组件：
// van-uploader / ImagePreview 等 Vant 内部组件是直接 import 使用，不经过全局组件注册，
// 组件层覆盖只能命中模板里手写的标签，覆盖不到这些内部结构。
// 而 Vue 2 渲染时 src / href / poster / data 都不在 mustUseProp 白名单内，
// 最终统一落到 el.setAttribute 或 DOM property setter 上，因此在 DOM 层拦截可以一次性覆盖：
//   图片缩略图、大图预览、非图片文件的 iframe 预览、下载链接、新窗口打开、视频封面等。
//
// 只处理会发起文件请求的属性；替换函数本身只匹配 /relay/cosfile，
// 不匹配的地址（路由链接、外链、CSS、JS）原样返回，不影响正常渲染。
// 用法：在 main.js 中 $processImageUrl 定义之后调用 registerFileUrlGuard()

// 参与链接补全的标签与属性白名单
const URL_TAG_ATTRS = {
  img: ['src'],
  iframe: ['src'],
  video: ['src', 'poster'],
  audio: ['src'],
  source: ['src'],
  embed: ['src'],
  object: ['data'],
  a: ['href'],
};

export function registerFileUrlGuard() {
  const processUrl = (url) => {
    const fn = Vue.prototype.$processImageUrl;
    return typeof fn === 'function' ? fn(url) : url;
  };

  // 1) 拦截 DOM property setter（img.src、a.href、iframe.src、video.src/poster 等）
  const patchUrlSetter = (ctor, prop) => {
    try {
      // 属性描述符可能定义在父类原型上，向上查找真正的定义位置
      let owner = ctor.prototype;
      let desc = null;
      while (owner) {
        const d = Object.getOwnPropertyDescriptor(owner, prop);
        if (d && typeof d.set === 'function') {
          desc = d;
          break;
        }
        owner = Object.getPrototypeOf(owner);
      }
      if (!desc || desc.set.__fileUrlPatched) return;

      const originalSet = desc.set;
      const patchedSet = function (value) {
        if (typeof value === 'string' && value) {
          return originalSet.call(this, processUrl(value));
        }
        return originalSet.call(this, value);
      };
      patchedSet.__fileUrlPatched = true;
      Object.defineProperty(owner, prop, {
        configurable: true,
        enumerable: desc.enumerable,
        get: desc.get,
        set: patchedSet,
      });
    } catch (e) {
      console.warn(`[permission] 拦截 ${prop} 失败：`, e);
    }
  };

  const win = typeof window !== 'undefined' ? window : {};
  const SETTER_TARGETS = [
    [win.HTMLImageElement, 'src'],
    [win.HTMLAnchorElement, 'href'],
    [win.HTMLIFrameElement, 'src'],
    [win.HTMLVideoElement, 'src'],
    [win.HTMLVideoElement, 'poster'],
    [win.HTMLAudioElement, 'src'],
    [win.HTMLSourceElement, 'src'],
    [win.HTMLObjectElement, 'data'],
    [win.HTMLEmbedElement, 'src'],
  ];

  for (let i = 0; i < SETTER_TARGETS.length; i += 1) {
    const ctor = SETTER_TARGETS[i][0];
    const prop = SETTER_TARGETS[i][1];
    if (ctor) patchUrlSetter(ctor, prop);
  }

  // 2) 拦截 setAttribute，覆盖 Vue 模板渲染（Vue 2 的 attrs 最终都走 el.setAttribute）
  try {
    const originalSetAttribute = Element.prototype.setAttribute;
    if (!originalSetAttribute.__fileUrlPatched) {
      const patchedSetAttribute = function (name, value) {
        if (typeof name === 'string' && typeof value === 'string' && this.tagName) {
          const attr = name.toLowerCase();
          const allowAttrs = URL_TAG_ATTRS[this.tagName.toLowerCase()];
          if (allowAttrs && allowAttrs.indexOf(attr) !== -1) {
            return originalSetAttribute.call(this, name, processUrl(value));
          }
        }
        return originalSetAttribute.call(this, name, value);
      };
      patchedSetAttribute.__fileUrlPatched = true;
      Element.prototype.setAttribute = patchedSetAttribute;
    }
  } catch (e) {
    console.warn('[permission] 拦截 setAttribute 失败：', e);
  }

  // 3) 拦截企业微信原生预览 previewFile 的 url
  //    企微 SDK 在 index.html 中先于 bundle 加载，此时 wx / ww 已存在。
  //    不改写时，非图片文件会带着旧路径去请求，导致原生预览失败并降级到 iframe 弹窗。
  const patchWxPreviewFile = (api) => {
    if (!api || typeof api.invoke !== 'function' || api.invoke.__fileUrlPatched) return;
    const originalInvoke = api.invoke;
    const patchedInvoke = function (name, params, ...rest) {
      if (name === 'previewFile' && params && typeof params.url === 'string') {
        return originalInvoke.call(
          this,
          name,
          Object.assign({}, params, { url: processUrl(params.url) }),
          ...rest
        );
      }
      return originalInvoke.call(this, name, params, ...rest);
    };
    patchedInvoke.__fileUrlPatched = true;
    try {
      api.invoke = patchedInvoke;
    } catch (e) {
      console.warn('[permission] 拦截 previewFile 失败：', e);
    }
  };

  try {
    patchWxPreviewFile(win.wx);
    patchWxPreviewFile(win.ww);
  } catch (e) {
    console.warn('[permission] 获取企微 SDK 失败：', e);
  }
}

router.beforeEach(async (to, from, next) => {
  // 从七彩石配置中心拉取配置
  document.title = getPageTitle(to.meta && to.meta.title);
  if (!config.group && !!sessionStorage.getItem('userid')) {
    try {
      await dispatch('config/getConfigFromRainbow');
      aegis.setConfig({
        id: getters.getConfigItem('wechat_aegis_key') || AEGIS[process.env.VUE_APP_CONFIG_GROUP], // 上报 id
        uin: sessionStorage.getItem('userid') || undefined,
      });
    } catch (e) {}
  }
  next();
});
 
const title = '腾讯工单';
const getPageTitle = (pageTitle) => (pageTitle ? `${pageTitle} - ${title}` : title);
